import React from 'react'
import style from "css/myreservation.module.css";
import PersonalCard from './personalCard';
import { Empty, Spin } from 'antd';

function DepartmentStatus({ myInfo, colleagueList, isLoading }) {
    return (
        <div className={style.dept_wrapper}>
            <div className={style.dept_title}>
                {myInfo?.DEPARTMENT_NM}
            </div>
            {
                isLoading
                    ?
                    <div style={{ height: "calc(100% - 48.5px)", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Spin size='large' />
                    </div>
                    :
                    colleagueList?.length > 0
                        ?
                        <div className={style.dept_list_wrapper}>
                            <div className={style.dept_list_container}>
                                {
                                    colleagueList?.map((colleague, idx) => (
                                        <PersonalCard
                                            key={idx}
                                            colleague={colleague}
                                            isHotdesking={colleague.MEETING === null && colleague.HOTDESKING !== null}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                        :
                        <div style={{ height: "calc(100% - 48.5px)", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>
            }
        </div>
    )
}

export default DepartmentStatus
